import { ApiClient } from '@carpenter/utils';

declare const App: {
   useSecureCookies?: boolean;
   sameSiteValue?: 'Lax' | 'None' | 'Strict';
};

export const apiClient = new ApiClient({
   csrfCookieOptions: {
      secure: App.useSecureCookies,
      sameSite: App.sameSiteValue,
   },
});
